export const RESULTS_DATE_FORMAT = 'D MMMM'
export const RESULTS_EVENT_DATE_FORMAT = (text: string) =>
  text ? `DD.MM.YY [${text}] HH:mm` : `DD.MM.YY HH:mm`
